const datasetNamespaceActions = {
  ADD_DATASET_NAMESPACE: 'ADD_DATASET_NAMESPACE',
  CLOSE_DATASET_NAMESPACES: 'CLOSE_DATASET_NAMESPACES',
  FETCH_DATASET_NAMESPACES: 'FETCH_DATASET_NAMESPACES',
  FETCH_DATASET_NAMESPACES_ERROR: 'FETCH_DATASET_NAMESPACES_ERROR',
  FETCH_DATASET_NAMESPACES_SUCCESS: 'FETCH_DATASET_NAMESPACES_SUCCESS',
  REMOVE_DATASET_NAMESPACE: 'REMOVE_DATASET_NAMESPACE',
  REMOVE_DATASET_NAMESPACE_SUCCESS: 'REMOVE_DATASET_NAMESPACE_SUCCESS',
  UPDATE_DATASET_NAMESPACES_ERROR: 'UPDATE_DATASET_NAMESPACES_ERROR',
  ADD_DATASET_NAMESPACE_SUCCESS: 'ADD_DATASET_NAMESPACE_SUCCESS',
};

export const datasetNamespacesCategories = ['open'];

export const invalidSchemas = {
  prefixes: ['pg_'],
  reserved: [
    'internal_date',
    'audit_logs',
    'analytics',
  ],
};

export default datasetNamespaceActions;
